// src/services/QuestionarioService/QuestionarioService.js
import ApiService from "../ApiService"; // Assicurati che il percorso ad ApiService sia corretto

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class QuestionarioService {

  /**
   * Recupera le domande del questionario dal backend
   * @param {string} codice - Il codice del questionario (es. 'SOD_ASC_01')
   */
  static getQuestionario(codice) {
    return new Promise((resolve, reject) => {
      // Usiamo un GET con query param come definito nel controller
      const url = `${REACT_APP_REST_ENDPOINT}/questionario/get?codice=${codice}`;
      ApiService.getRequest(resolve, reject, url);
    });
  }

  /**
   * Invia le risposte anonime al backend
   * @param {object} data - Il payload completo da inviare
   * (include id_questionario, id_corso, id_classe, id_classe_utente, risposte, suggerimento)
   */
  static salvaRisposte(data) {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/questionario/salva`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  }
}